import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  size?: 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-300 transform hover:-translate-y-1';
  const variants = {
    primary: 'bg-brand-accent hover:bg-brand-accentHover text-brand-darker shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)]',
    outline: 'border-2 border-brand-accent text-brand-accent hover:bg-brand-accent hover:text-brand-darker'
  };
  const sizes = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl sm:text-2xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <a href={href} className={classes} data-id="element-350">
        {children}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-351">
      {children}
    </button>;
}